import script from "./CompanyGroups.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyGroups.vue?vue&type=script&setup=true&lang=js"

import "./CompanyGroups.vue?vue&type=style&index=0&id=394d98b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-394d98b0"]])

export default __exports__